// extracted by mini-css-extract-plugin
export default {"platformNotices":"PlatformNoticesPage_platformNotices__QSbl3","platformNoticesTable":"PlatformNoticesPage_platformNoticesTable__duj1T"};